// Module
var code = "<?xml version=\"1.0\" encoding=\"UTF-8\"?> <svg viewBox=\"0 0 100 50\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"> <title>number_selector_wide</title> <path d=\"M0 50 Q15 47 35 20 Q50 5 65 20 Q85 47 100 50 Z\" stroke-width=\"0.2\" stroke=\"#1F9E9E\" fill=\"#1F9E9E\"/> </svg> ";
// Exports
module.exports = code;